import { FC } from 'react';
import {
  ColumnDateFilter,
  ColumnSelectFilter,
  FilterSection,
} from 'components/data-table';
import { capitalize } from 'lodash-es';

interface StructureGridCollectionFiltersProps {
  basins: string[];
  owners: string[];
  validityOptions: (string | null | undefined)[];
}

const BOOLEAN_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

const StructureGridCollectionFilters: FC<
  StructureGridCollectionFiltersProps
> = ({ basins, owners, validityOptions }) => {
  return (
    <>
      <FilterSection title="Date Filters">
        <ColumnDateFilter
          columnId="sourceCollectionCreatedAt"
          label="Created Date"
          startPlaceholder="From mm/dd/yyyy"
          endPlaceholder="To mm/dd/yyyy"
        />
      </FilterSection>

      <FilterSection title="Structure Grid Collection Details">
        <ColumnSelectFilter
          columnId="basin"
          label="Basin"
          options={basins.map((b) => ({ value: b, label: b }))}
          placeholder="All"
        />
        <ColumnSelectFilter
          columnId="owner"
          label="Collection Owner"
          options={owners.map((o) => ({ value: o, label: o }))}
          placeholder="All"
        />
        <ColumnSelectFilter
          columnId="landingAutoUpdateEnabled"
          label="Auto Update Status"
          options={BOOLEAN_OPTIONS}
          placeholder="All"
        />
        <ColumnSelectFilter
          columnId="isDefault"
          label="Default Status"
          options={BOOLEAN_OPTIONS}
          placeholder="All"
        />
        <ColumnSelectFilter
          columnId="validity"
          label="Collection Validity"
          options={validityOptions
            .filter((v) => v && v !== 'All')
            .map((v) => ({ value: v!, label: capitalize(v!) }))}
          placeholder="All"
        />
      </FilterSection>
    </>
  );
};

export { StructureGridCollectionFilters };
